<ng-container *ngFor="let group of asFilterSetGroups(layout); let idx = index">
  <div
    *ngIf="idx === 0"
    class="d-flex flex-wrap"
    [ngClass]="[
      asFilterSetGroups(layout).length === 1 ? 'col-lg-12' : 'col-lg-8',
      isMeasuredBenchmark(filterConfig.dashboardLiteralId)
        ? 'gap-6 items-end w-max flex-nowrap px-0'
        : 'gap-3',
    ]">
    <ng-container *ngIf="showChild">
      <div class="saved-time">
        <p class="saved-time-text">
          <span class="time-label">Historical reference date: </span>
          <span>{{ formatRangeDate }}</span>
        </p>
      </div>
    </ng-container>
    <ng-container
      *ngFor="let item of asContext(group)"
      class="filterSetAppendTo">
      <div
        *ngIf="
          (!showChild && item.name !== 'childCampaign') ||
          (showChild && item.name === 'childCampaign')
        ">
        <ng-template
          [ngIf]="
            item.layoutType === 'dateRange' || item.layoutType === 'DATE_RANGE'
          "
          [ngIfElse]="elseBlock">
          <!-- Use portal-fiscal-calendar when isCustomCalendar() is true for cross-channel dashboards -->
          @if (isCustomCalendar()) {
            <portal-fiscal-calendar
              [label]="item.label"
              [months]="months()"
              [minDate]="minDate"
              [maxDate]="maxDate"
              [datePickerInputHeight]="'2rem'"
              [startDate]="getDateRangeStart(item.value)"
              [endDate]="getDateRangeEnd(item.value)"
              [previousStartDate]="getCompareStartDate()"
              [previousEndDate]="getCompareEndDate()"
              [relativeDate]="$any(relativeDate?.value)"
              [hideAfterApply]="false"
              (dateChanged)="handleFiscalDateChange(idx, item.name, $event)">
            </portal-fiscal-calendar>
          } @else {
            <portal-date-range-picker
              [label]="item.label"
              [datePickerInputHeight]="'2rem'"
              [dateFilter]="item"
              [compareFilter]="compareFilter"
              [ngClass]="[item.layoutType, item.name, 'context-filter']"
              [leftSide]="true"
              [showInputPickers]="
                !isMeasuredBenchmark(filterConfig.dashboardLiteralId)
              "
              [showPresetSelection]="
                !isMeasuredBenchmark(filterConfig.dashboardLiteralId)
              "
              [minDate]="minDate"
              [maxDate]="maxDate"
              [dateFormatType]="monthDateYearFormat"
              [date]="setAsDateRange(item.value)"
              [relativeDate]="relativeDate"
              (dateChanged)="
                updateDateRange(idx, item.name, $event)
              "></portal-date-range-picker>
          }
        </ng-template>
        <ng-template #elseBlock>
          <label
            [ngClass]="[item.layoutType, item.name, 'context-filter', 'h-100']"
            ><span class="b2 text-gray-800">{{ item.label }}</span>
            <div
              *ngIf="item.layoutType === layoutTypes.verticalSeperator"
              class="h-100">
              <portal-seperator
                [layoutType]="item.layoutType"></portal-seperator>
            </div>
            <div
              *ngIf="
                item.layoutType === 'select' || item.layoutType === 'SELECT'
              "
              [class.benchmarks-view-select]="isBenchmarksViewFilter(item)">
              <ng-template
                #benchmarksViewOption
                let-label="label"
                let-value="value">
                <div class="option-content">
                  <span
                    tooltipPosition="right"
                    [pTooltip]="label.length >= 27 ? label : ''"
                    tooltipStyleClass="saas-tooltip"
                    class="option-name"
                    >{{ label | ellipsis: 27 }}</span
                  >
                  <m-type-pill
                    class="ml-2"
                    [size]="typePillSize.small"
                    [text]="value ? 'Tactic' : 'Channel'"></m-type-pill>
                </div>
              </ng-template>
              <ng-template #benchmarksViewItemTemplate let-option>
                <ng-container
                  *ngTemplateOutlet="
                    benchmarksViewOption;
                    context: { label: option.label, value: option.value }
                  "></ng-container>
              </ng-template>
              <m-dropdown
                [(ngModel)]="item.value"
                [options]="item.options"
                [width]="isBenchmarksViewFilter(item) ? '13rem' : undefined"
                [showClear]="false"
                [filter]="false"
                [baseZIndex]="2"
                [appendTo]="filterSetAppendTo"
                [panelStyleClass]="filterConfig.dashboardLiteralId"
                [customTemplate]="
                  isBenchmarksViewFilter(item)
                    ? benchmarksViewItemTemplate
                    : undefined
                "
                (onShow)="cacheValue(item.name, item.value)"
                (onHide)="updateContextFilter(idx, item.name)"
                scrollHeight="20rem"
                [placeholder]="item.label"
                [disabled]="isFiltersUpdating">
              </m-dropdown>
              <div
                *ngIf="isBenchmarksViewFilter(item)"
                class="benchmarks-view-select__label">
                <ng-container
                  *ngTemplateOutlet="
                    benchmarksViewOption;
                    context: {
                      label: getBenchmarksViewLabel(item),
                      value: item.value,
                    }
                  "></ng-container>
              </div>
            </div>
            <m-multiselect
              *ngIf="
                item.layoutType === 'multiselect' ||
                item.layoutType === 'MULTI_SELECT'
              "
              #multiSelect
              [virtualScroll]="item.useVirtualScroll"
              [virtualScrollItemSize]="44"
              [ngModel]="
                isHaloToggleOn && item.exclusionGroup ? [] : item.value
              "
              (ngModelChange)="item.value = $event"
              [disabled]="
                isFiltersUpdating || (isHaloToggleOn && !!item.exclusionGroup)
              "
              [defaultLabel]="
                isHaloToggleOn && item.exclusionGroup
                  ? '0 Selected'
                  : item.label
              "
              [options]="item.options"
              [filter]="true"
              filterBy="label"
              filterPlaceHolder="Search"
              [baseZIndex]="2"
              (onPanelShow)="cacheValue(item.name, item.value)"
              (onChange)="
                handleFilteredMultiSelectAllSelectionDeSelection(
                  idx,
                  multiSelect,
                  item.name
                )
              "
              (onPanelHide)="updateContextFilter(idx, item.name)"
              scrollHeight="20rem"
              [appendTo]="filterSetAppendTo"
              [maxSelectedLabels]="1"
              [selectedItemsLabel]="'{0} Selected'">
              <ng-template *ngIf="item.additionalFields" pTemplate="footer">
                <div class="additional-fields-message">
                  A few {{ item.label | lowercase }} may not be visible due
                  <br />
                  to chosen filters.
                  <span
                    class="filter-footer-link"
                    (click)="onMultiselectFooterClickHandler(item)"
                    >View all {{ item.label | lowercase }}</span
                  >
                </div>
              </ng-template>
            </m-multiselect>
            <p-inputgroup *ngIf="item.layoutType === 'NUMBER_INPUT_BOX'">
              <p-inputgroup-addon>$</p-inputgroup-addon>
              <p-inputNumber
                (onBlur)="updateContextFilter(idx, item.name)"
                (onKeyDown)="onKeyDown(idx, item.name, $event)"
                [(ngModel)]="item.value"
                [minFractionDigits]="2"></p-inputNumber>
            </p-inputgroup>

            <p-selectButton
              *ngIf="item.layoutType === 'TOGGLE'"
              name="toggle"
              class="filter-toggle"
              [options]="asStringArray(item.options)"
              [(ngModel)]="item.value"
              (onChange)="updateContextFilter(idx, item.name)">
            </p-selectButton>
            <m-button-group
              *ngIf="item.layoutType === 'buttonGroup'"
              [options]="item.options"
              [(selectedOption)]="item.value"
              (selectedOptionChange)="updateContextFilter(idx, item.name)">
            </m-button-group> </label
        ></ng-template>
      </div>
      <ng-container
        *ngIf="
          item.layoutType === layoutTypes.verticalSeperator &&
          exclusionGroupConfig
        ">
        <label class="halo-toggle-wrapper context-filter">
          <span class="b2 text-gray-800"
            >{{ exclusionGroupConfig.keyword }} effect</span
          >
          <m-switch
            [(ngModel)]="isHaloToggleOn"
            [disabled]="isFiltersUpdating"
            (onChange)="onHaloToggleChange($event.checked)">
          </m-switch>
        </label>
      </ng-container>
    </ng-container>
    <label class="reset-filters" *ngIf="showResetSelection">
      <m-button
        *ngIf="showResetSelection"
        class="b2"
        type="tertiary"
        (click)="resetFilterSelection()">
        <span class="b2"> Reset selections </span>
      </m-button>
    </label>
  </div>

  <div
    *ngIf="idx === 1"
    class="custom-opt-div col-lg-4 mt-md-2 mt-lg-0 d-flex justify-content-start justify-content-lg-end"
    [ngClass]="{
      'px-0': isMeasuredBenchmark(filterConfig.dashboardLiteralId),
    }">
    <ng-container *ngFor="let item of asContext(group)">
      <portal-date-range-picker
        *ngIf="
          item.layoutType === 'dateRange' || item.layoutType === 'DATE_RANGE'
        "
        [source]="'nativeDashBoard'"
        [label]="item.label"
        [dateFilter]="item"
        [compareFilter]="compareFilter"
        [ngClass]="[item.layoutType, item.name, 'context-filter']"
        [leftSide]="false"
        [showInputPickers]="
          !isMeasuredBenchmark(filterConfig.dashboardLiteralId)
        "
        [showPresetSelection]="
          !isMeasuredBenchmark(filterConfig.dashboardLiteralId)
        "
        [maxDate]="maxDate"
        [dateFormatType]="monthDateYearFormat"
        [date]="setAsDateRange(item.value)"
        [relativeDate]="relativeDate"
        (dateChanged)="
          updateDateRange(idx, item.name, $event)
        "></portal-date-range-picker>
      <ng-container *ngIf="item.layoutType === 'DOWNLOAD_ICON'">
        <m-button
          type="tertiary"
          styleClass="p-button-icon-only"
          pTooltip="Export your plan"
          tooltipPosition="bottom"
          tooltipStyleClass="saas-tooltip"
          showDelay="800"
          (click)="menu.toggle($event); getExportMenu(item)">
          <span class="material-symbols-outlined"> ios_share </span>
        </m-button>
        <p-menu #menu [popup]="true" appendTo="body" [model]="exportMenu">
        </p-menu>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
<ng-container *ngIf="isFilterPopupVisible">
  <portal-popup
    [(dialogVisibility)]="isFilterPopupVisible"
    [dialogTitle]="'All ' + filterPopupDialogTitle"
    dialogSubTitle="All of your {{
      filterPopupDialogTitle | lowercase
    }}, independent of filtering options"
    [tableColumns]="filterPopupTableColumns"
    (dialogVisibilityChange)="closeFilterPopup()"
    [tableData]="filterPopupTableData"></portal-popup>
</ng-container>

<portal-halo-spend-modal
  [(visible)]="isHaloModalVisible"
  [exclusionGroupConfig]="exclusionGroupConfig"
  [currentBrandName]="selectionService.clientBrandSignal().brandName"
  (enable)="onHaloModalEnable($event)"
  (closed)="onHaloModalClose($event)">
</portal-halo-spend-modal>
